export default __webpack_public_path__ + "static/media/bhagwanyoga.8eff76e4.png";